// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import CodeSandboxSquareFilledSvg from "@ant-design/icons-svg/es/asn/CodeSandboxSquareFilled";
import AntdIcon from '../components/AntdIcon';

var CodeSandboxSquareFilled = function CodeSandboxSquareFilled(props, ref) {
  return React.createElement(AntdIcon, Object.assign({}, props, {
    ref: ref,
    icon: CodeSandboxSquareFilledSvg
  }));
};

CodeSandboxSquareFilled.displayName = 'CodeSandboxSquareFilled';
export default React.forwardRef(CodeSandboxSquareFilled);


//////////////////
// WEBPACK FOOTER
// ./node_modules/_@ant-design_icons@4.0.6@@ant-design/icons/es/icons/CodeSandboxSquareFilled.js
// module id = 821
// module chunks = 0